var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"section-header"},[_c('h4',{staticClass:"headings-h4"},[_vm._v(_vm._s(_vm.title))]),(_vm.subtitle)?_c('small',{staticClass:"text-body-small"},[_vm._v(_vm._s(_vm.subtitle))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }